<!-- CollapsePanel.vue -->
<template>
  <div class="collapse-box" v-show="is_show" :class="{ 'is-expanded': expanded }">
    <div class="collapse-label" @click="handleClick">
      <!-- <Badge :status="is_thinking ? 'processing' : 'default'" /> -->
      <SvgIcon :class ="['svgico', is_thinking ? 'rotating' : '']" width="14" height="14" />
      <span>{{ label }}</span>
       <div class="collapse-arrow" :class="{ rotated: expanded }">
        <svg
          viewBox="0 0 14 14"
          class="arrow-icon"
        >
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M2.642.497a.75.75 0 0 0-1.06 0l-.53.53a.75.75 0 0 0 0 1.06l5.415 5.416c.147.147.34.22.533.22a.75.75 0 0 0 .533-.22l5.415-5.415a.75.75 0 0 0 0-1.06l-.53-.53a.75.75 0 0 0-1.06 0L7 4.854z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
    </div>
    <div class="collapse-content" :style="contentStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../common/svgicon.vue'
export default {
  name: 'CollapsePanel',
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '点击展开/折叠内容'
    },
    is_thinking: {
      type: Boolean,
      default: false,
    },
    is_show:{
      type:Boolean,
      default:false,
    }
  },
  computed: {
    contentStyle() {
      return {
        maxHeight: this.expanded ? '100%' : '0',
        padding: this.expanded ? '0 0 0 20px' : '0 0 0 20px'
      }
    }
  },
  components:{
    SvgIcon
  },
  methods: {
    handleClick() {
      this.$emit('toggle', !this.expanded)
    }
  }
}
</script>

<style scoped>
.collapse-box {
  margin: 10px;
  border-radius: 8px; /* 增大圆角半径 */
  font-size: 14px;
  overflow: hidden; /* 新增 */  /* 确保内部元素遵守圆角 */
  transition: border-radius 0.3s; /* 添加圆角过渡 */

}

/* 展开时调整底部圆角 */
.collapse-box.is-expanded {
  border-radius: 8px 8px 4px 4px; /* 底部圆角稍小保持视觉平衡 */
}

.collapse-label {
  display: flex;
  align-items: center;
  padding: 12px 12px;
  cursor: pointer;
  transition: background 0.3s;
  border-radius: 8px 8px 0 0; /* 顶部圆角 */
  background: #E8F7FF;
  font-size: 14px;
  .svgico{
    position: relative;
    top: -1px;
    right:2px;
    color:#165DFF;
  }
}

.collapse-label:hover {
  background: #C3E7FE;
}

/* 修改箭头容器样式 */
.collapse-arrow {
  flex-shrink: 0;
  width: 0.7em;      /* 固定容器尺寸 */
  height: 0.7em;     /* 与字体大小一致 */
  margin-left: 5px;
  position: relative; /* 新增定位基准 */
}

/* 精准居中 SVG 并固定旋转中心 */
.arrow-icon {
  position: absolute;
  top: 70%;
  left: 50%;
  width: 0.7em;   /* 保持原有比例 */
  height: 0.7em;
  transform: translate(-50%, -50%); /* 精准居中 */
  transform-origin: center;         /* 围绕中心旋转 */
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

}

/* 添加硬件加速优化 */
.collapse-arrow.rotated {
  transform: rotate(180deg);
  backface-visibility: hidden; /* 避免旋转时抖动 */
}

.collapse-content {
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 0 0 4px 4px; /* 底部圆角 */
  margin-left: 0; /* 移除原左边距 */
  padding-left: 12px !important; /* 改用padding保持缩进 */
  position: relative; /* 使伪元素可以相对于它定位 */
  background-color: white;
  color:#808695;
}

.collapse-content::before {
  content: ""; /* 伪元素必须有content属性 */
  position: absolute;
  top: 10px; /* 竖线从顶部开始 */
  bottom: 10px; /* 竖线延伸到底部 */
  left: 0; /* 竖线紧贴左侧 */
  width: 2px; /* 竖线的宽度 */
  background-color: #e8eaec; /* 竖线的颜色 */
}

.collapse-content p {
  margin: 0;
  padding: 2px 0;

}

/*svgico自旋*/
/*设置 is_thinking = true，此时 <SvgIcon> 会应用 rotating 类，开始旋转动画。*/
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 2s linear infinite;
}

</style>